import {computed} from "vue";
import {useAuthenticationStore} from "../stores/authenticationStore.js";
import {RoutesMigrated} from "@/modern/RoutesMigrated";

export const useUserInfo = () => {
    const useUserInfoStore = useAuthenticationStore()
    const userInfo = computed(() => useUserInfoStore.userInfo)
    const userInfoLoaded = computed(() => useUserInfoStore.dataLoaded)
    const hasUserNotAuthorized = computed(() => useUserInfoStore.hasError)

    const isLegacyOrganization = computed(() => {
        return false;
    })

    const isLegacyTheme = (routeName) => {
        const currentRouteName = routeName;
        // Se a rota não estiver mapeada, considerar como legacy por segurança
        if (!(currentRouteName in RoutesMigrated)) {
            return true;
        }
        // Retorna true se a rota não foi migrada (valor false em RoutesMigrated)
        return !RoutesMigrated[currentRouteName];
    }

    return {
        userInfo,
        userInfoLoaded,
        hasUserNotAuthorized,
        isLegacyTheme,
        isLegacyOrganization,
    }
}